import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import AddDurableArticlesWidget from '../../../widgets/durableArticlesWidget/addDurableArticlesWidget/AddDurableArticlesWidget'
import { getAssetRegister } from '../../../redux/actions/addDurableArticles'
import { sessionGetItemStr, sessionGetItemObj } from '../../../utils/sessionHelpers'

export default function AssetHistory() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetRegister(projectCode, 1)
      // _schema.model.disabled = false // test edit mode
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader
          header={schema.header}
          subHeader={''}
          isNotCallApi
          isShowGoButton
          cleanSessions={['projectCode']}
        />

        <AddDurableArticlesWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
